import { useEffect, useRef } from "react";

import { useLoomControlSurfaceContext } from "./LoomControlSurfaceContext";

export interface LoomControlRuntimeState {
  readonly legacyControlPoseRevision: string | null;
  readonly selectedControlSide: "port" | "starboard" | "both" | null;
  readonly selectedControlSurfaceId: string | null;
}

function same(left: LoomControlRuntimeState, right: LoomControlRuntimeState): boolean {
  return left.legacyControlPoseRevision === right.legacyControlPoseRevision
    && left.selectedControlSide === right.selectedControlSide
    && left.selectedControlSurfaceId === right.selectedControlSurfaceId;
}

export function LoomControlRuntimeObserver({
  onChange,
}: { readonly onChange: (state: LoomControlRuntimeState) => void }) {
  const controls = useLoomControlSurfaceContext();
  const previous = useRef<LoomControlRuntimeState | null>(null);
  const selectedControlSide = controls?.selectedBodyId?.endsWith(":port") ? "port"
    : controls?.selectedBodyId?.endsWith(":starboard") ? "starboard"
      : controls?.selectedControl ? "both" : null;
  const state: LoomControlRuntimeState = {
    legacyControlPoseRevision: controls?.poseRevision ?? null,
    selectedControlSide,
    selectedControlSurfaceId: controls?.selectedControl?.id ?? null,
  };
  useEffect(() => {
    if (previous.current && same(previous.current, state)) return;
    previous.current = state;
    onChange(state);
  }, [onChange, state.legacyControlPoseRevision, state.selectedControlSide, state.selectedControlSurfaceId]);
  return null;
}
